(function(){
  'use strict';
  function ready(fn){document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn,{once:true}):fn();}
  function clamp(v,min,max){return Math.max(min,Math.min(max,v));}

  ready(function(){
    /* Technical specifications are intentionally fully expanded. */
    function openTech(){
      document.querySelectorAll('.mg2-pdp-tech__group').forEach(function(group){group.open=true;});
    }
    openTech();
    setTimeout(openTech,250);
    setTimeout(openTech,900);

    /* Full gallery pack follows the user through the long purchase column. */
    var main = document.querySelector('.lbx-product-main');
    var mediaCol = main && main.querySelector('.lbx-product-media-col');
    var infoCol = main && main.querySelector('.lbx-product-info');
    var raf = 0;
    function updateGalleryFollow(){
      raf = 0;
      if(!main || !mediaCol || !infoCol) return;
      if(window.matchMedia('(max-width:1100px)').matches){
        mediaCol.style.setProperty('--lbx-final-gallery-y','0px');
        return;
      }
      var mainTop = main.getBoundingClientRect().top + window.pageYOffset;
      var mediaOffset = mediaCol.offsetTop || 0;
      var baseTop = mainTop + mediaOffset;
      var maxShift = Math.max(0, infoCol.offsetHeight - mediaCol.offsetHeight);
      var wanted = window.pageYOffset + 96 - baseTop;
      var shift = clamp(wanted,0,maxShift);
      mediaCol.style.setProperty('--lbx-final-gallery-y',shift.toFixed(1)+'px');
    }
    function requestGalleryFollow(){if(!raf) raf=requestAnimationFrame(updateGalleryFollow);}
    if(main && mediaCol && infoCol){
      window.addEventListener('scroll',requestGalleryFollow,{passive:true});
      window.addEventListener('resize',requestGalleryFollow,{passive:true});
      if(window.ResizeObserver){
        var ro = new ResizeObserver(requestGalleryFollow);
        ro.observe(main); ro.observe(mediaCol); ro.observe(infoCol);
      }
      requestGalleryFollow();
      setTimeout(requestGalleryFollow,250);
      setTimeout(requestGalleryFollow,1000);
    }

    /* One lightweight handler for the full description modal. */
    function lockModal(lock){
      document.documentElement.classList.toggle('lbx-final-modal-open',!!lock);
      document.body.classList.toggle('lbx-final-modal-open',!!lock);
    }
    function closeStory(modal){
      if(!modal) return;
      try{
        var focused=document.activeElement;
        if(focused && modal.contains(focused)) focused.blur();
      }catch(e){}
      modal.setAttribute('inert','');
      modal.hidden=true;
      modal.setAttribute('aria-hidden','true');
      lockModal(false);
    }
    document.addEventListener('click',function(event){
      var opener = event.target.closest('[data-lbx-story-readmore-open]');
      if(opener){
        event.preventDefault();
        var modal = document.querySelector('[data-lbx-story-modal]');
        if(!modal) return;
        modal.hidden=false;
        modal.removeAttribute('inert');
        modal.setAttribute('aria-hidden','false');
        var scroller = modal.querySelector('[data-lbx-story-scroll]');
        if(scroller) scroller.scrollTop=0;
        lockModal(true);
        return;
      }
      var closer = event.target.closest('[data-lbx-story-readmore-close]');
      if(closer){
        event.preventDefault();
        closeStory(closer.closest('[data-lbx-story-modal]') || document.querySelector('[data-lbx-story-modal]:not([hidden])'));
      }
    },true);
    document.addEventListener('keydown',function(event){
      if(event.key==='Escape') closeStory(document.querySelector('[data-lbx-story-modal]:not([hidden])'));
    });

    /* Top CTA jumps to the actual financing calculator and opens it. */
    document.addEventListener('click',function(event){
      var trigger = event.target.closest('[data-lbx-finance-jump]');
      if(!trigger) return;
      var selector = trigger.getAttribute('href');
      if(!selector || selector.charAt(0)!=='#') return;
      var card = document.querySelector(selector);
      if(!card) return;
      event.preventDefault();
      card.scrollIntoView({behavior:'smooth',block:'center'});
      setTimeout(function(){
        var controls = card.querySelector('[data-lbx-finance-controls]');
        var toggle = card.querySelector('[data-lbx-finance-toggle]');
        if(controls && controls.hidden && toggle) toggle.click();
      },420);
    });
  });
})();
